/**
 * Side-by-side scan summary cards for comparison header.
 */

import { ArrowRight } from 'lucide-react';

interface ScanSummary {
  scanId: string;
  label: string;
}

interface ComparisonHeaderProps {
  scan1: ScanSummary;
  scan2: ScanSummary;
}

const ComparisonHeader = ({ scan1, scan2 }: ComparisonHeaderProps) => (
  <div className="flex items-center gap-4">
    <div className="flex-1 bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
      <p className="text-xs text-zinc-400 uppercase tracking-wider mb-1">Baseline (older)</p>
      <p className="font-mono text-sm text-white">{scan1.scanId}</p>
      <p className="text-xs text-zinc-500 mt-1">{scan1.label}</p>
    </div>
    <ArrowRight className="w-5 h-5 text-zinc-500 shrink-0" />
    <div className="flex-1 bg-zinc-800/50 border border-zinc-700 rounded-lg p-4">
      <p className="text-xs text-zinc-400 uppercase tracking-wider mb-1">Current (newer)</p>
      <p className="font-mono text-sm text-white">{scan2.scanId}</p>
      <p className="text-xs text-zinc-500 mt-1">{scan2.label}</p>
    </div>
  </div>
);

export default ComparisonHeader;
